import React from "react";
import { withRouter, Route, Switch, Redirect } from "react-router-dom";
import $ from "jquery";

import Header from "./../components/Header";
import Footer from "./../components/Footer";
import HomePage from "./../pages/HomePage";
import ContactPage from "./../pages/ContactPage";
import CarFleetPage from "./../pages/CarFleetPage";
import AboutUsPage from "./../pages/AboutUsPage";
import Motoconcierge from "./../pages/Motoconcierge";
import OfferPage from "./../pages/OfferPage";
import OfferShortPage from "./../pages/OfferShortPage";
import OfferLongPage from "./../pages/OfferLongPage";
import OfferSellPage from "./../pages/OfferSellPage";
import OfferFleet from "./../pages/OfferFleet";
import TermsAndConditionsPage from "./../pages/TermsAndConditionsPage";
import FaqPage from "./../pages/FaqPage";
import NoPage from "./../pages/NoPage";
import CarPage from "./../pages/CarPage";
import ErrorPage from "./../pages/ErrorPage";
import ModalWrapper from "../components/ModalContact/ModalWrapper";

import { ThemeContext, themes } from "./ThemeContext";

const headerColor = new Map([
  ["blog", "white"],
  ["faq", "black"],
  ["flota", "white"],
  ["kontakt", "white"],
  ["o-marce", "black"],
  ["motoconcierge", "white"],
  ["oferta", "white"],
  ["regulamin", "black"],
  ["404", "white"],
  ["error", "white"]
]);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.hideModalContact = () => {
      this.setState({
        modalContact: false
      });
    };

    this.showModalContact = () => {
      this.setState({
        modalContact: true
      });
    };

    this.state = {
      headerColor: themes.headerColor,
      // changeHeaderColor: this.changeHeaderColor,
      modalContact: false,
      showModalContact: this.showModalContact,
      hideModalContact: this.hideModalContact
    };

    this.doChangeSvg = null;
    this.setDefaultHeaderColor = this.setDefaultHeaderColor.bind(this);
  }

  setDefaultHeaderColor(equalString) {
    let setDefault = false;

    headerColor.forEach((val, key) => {
      setDefault = equalString.includes("flota");

      if (equalString.includes(key)) {
        this.setState({
          headerColor: val
        });
      }
    });

    this.setState({
      defaultScrolled: setDefault
    });
  }

  changeAllImagesToInlineSVG() {
    clearTimeout(this.doChangeSvg);
    this.doChangeSvg = setTimeout(() => {
      $("img.svg").each(function() {
        var $img = $(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL = $img.attr("src");

        $.get(
          imgURL,
          function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find("svg");

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== "undefined") {
              $svg = $svg.attr("id", imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== "undefined") {
              $svg = $svg.attr("class", imgClass + " replaced-svg");
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr("xmlns:a");

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (
              !$svg.attr("viewBox") &&
              $svg.attr("height") &&
              $svg.attr("width")
            ) {
              $svg.attr(
                "viewBox",
                "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
              );
            }

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          "xml"
        );
      });
    }, 1000);
  }

  componentDidMount() {
    this.changeAllImagesToInlineSVG();
    this.setDefaultHeaderColor(this.props.location.pathname);
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.changeAllImagesToInlineSVG();
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.setDefaultHeaderColor(nextProps.location.pathname);
      // this.changeHeaderColor();
    }
  }

  render() {
    const overflow = this.state.modalContact ? "hidden" : "initial";

    return (
      <div className="v1rage-app" style={{ overflow: overflow }}>
        <ThemeContext.Provider value={this.state}>
          <Header defaultScrolled={this.state.defaultScrolled} />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/kontakt" component={ContactPage} />
            <Route path="/o-marce" component={AboutUsPage} />
            <Route path="/motoconcierge" component={Motoconcierge} />

            <Route path="/flota" exact component={CarFleetPage} />
            <Route path="/flota/:id" exact component={CarPage} />

            <Route
              path="/oferta/wynajem-krotkookresowy"
              component={OfferShortPage}
            />
            <Route
              path="/oferta/wynajem-dlugookresowy"
              component={OfferLongPage}
            />
            <Route path="/oferta/sprzedaz" component={OfferSellPage} />
            <Route path="/oferta/obsluga-flot" component={OfferFleet} />
            <Route exact path="/oferta" component={OfferPage} />

            <Route exact path="/regulamin" component={TermsAndConditionsPage} />
            <Route exact path="/faq" component={FaqPage} />
            {/* <Route exact path="/blog" component={BlogPage} /> */}
            {/* <Route exact path="/blog-single" component={BlogSinglePage} /> */}
            <Route exact path="/error" component={ErrorPage} />
            <Route exact path="/404" component={NoPage} />
            <Redirect to="/404" />
          </Switch>
          {this.state.modalContact && <ModalWrapper />}
          <Footer />
        </ThemeContext.Provider>
      </div>
    );
  }
}
export default withRouter(App);
